






























import { Component, Vue } from "vue-property-decorator";
import UserService from "@/api/services/userService";
import LoginError from "@/api/models/loginError";
import LoginResponse from "@/api/models/loginResponse";

@Component
export default class Login extends Vue {
  api = new UserService(this);

  userName = "";
  password = "";

  sumbitted = false;
  errors: Record<string, string> = {};

  correct(propName: string): boolean {
    if (!this.sumbitted) {
      return true;
    }
    return this.errors[propName] === undefined;
  }

  async onSubmit(e: Event) {
    e.preventDefault();
    let isError = (r: LoginError | LoginResponse): r is LoginError => {
      return (r as LoginError).loginError !== undefined;
    };

    this.errors = {};
    let response = await this.api.login(this.userName, this.password);
    this.sumbitted = true;
    if (isError(response)) {
      this.errors = {
        userName: "User name or password is incorrect.",
        password: "User name or password is incorrect."
      };
    }
  }
}
